import React, { Component } from "react";
import { ListGroup } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";

class SideNav extends Component {
  state = {
    selectedItem: {},
    items: [
      { id: 1, label: <span>Invoices <Badge variant="danger">New</Badge></span>, link: `/invoices/${this.props.currentUser._id}` },
      { id: 2, label: "Services", link: "/my-services" },
      { id: 3, label: "Change Password", link: "/change-password" },
      // { id: 4, label: "Support", link: "/Support" },
    ],
  };

  handleSelect = (item) => {
    this.setState({ selectedItem: item });
  };

  render() {
    const { items, selectedItem } = this.state;
    return (
      <Paper elevation={3} className="mb-5">
        <ListGroup as="ul">
          {items.map((item) => (
            <Link
              key={item.id}
              className={item.id === selectedItem.id ? "sidenav-link-active" : "sidenav-link"}
              to={item.link}
            >
              <ListGroup.Item
                as="li"
                onClick={() => this.handleSelect(item)}
                className={item.id === selectedItem.id ? "card-actions main-color-bg" : "card-actions"}
              >
                {item.label}
              </ListGroup.Item>
            </Link>
          ))}
        </ListGroup>
      </Paper>
    );
  }
}

export default SideNav;
